// extracted by css-extract-rspack-plugin
export default {"SectionContainer":"Overview-module__SectionContainer__QU5D3zt","TableFooter":"Overview-module__TableFooter__UWugGZT"};